
export default {
	props: {
		/** 是否是成品号 */
		isAccount: {
			type: Boolean,
			default: true
		},
		/** 是否是顶级账号 */
		isAccountTop: {
			type: Boolean
		},
		/** 包赔 1->找回包赔 2->不可包赔  */
		compensation: {
			type: Number
		},
		/** 是否支持放心购 */
		isConfidence: {
			type: Boolean
		},
		/** 是否支持花呗分期 */
		isAntCreditPay: {
			type: Boolean
		},
		// 非成品号属性
		/** 卖家 1->个人卖家 2->签约卖家  */
		sellerType: {
			type: Number
		},
		/** 发货时间 */
		shipmentTimeText: {
			type: String
		}
	}
}
